var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisadvantageTitleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 18.75,
    fill: "#FFBDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7232 24.8303C15.8388 24.8303 16.7535 23.9155 16.7535 22.7999C16.7535 21.6843 15.8388 20.7695 14.7232 20.7695C13.6076 20.7695 12.6705 21.6843 12.6928 22.7999C12.6705 23.9155 13.6076 24.8303 14.7232 24.8303Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4417 24.8303C23.5573 24.8303 24.4721 23.9155 24.4721 22.7999C24.4721 21.6843 23.5573 20.7695 22.4417 20.7695C21.3261 20.7695 20.389 21.6843 20.4113 22.7999C20.389 23.9155 21.3261 24.8303 22.4417 24.8303Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1602 24.8303C31.2758 24.8303 32.1906 23.9155 32.1906 22.7999C32.1906 21.6843 31.2758 20.7695 30.1602 20.7695C29.0446 20.7695 28.1075 21.6843 28.1298 22.7999C28.1075 23.9155 29.0446 24.8303 30.1602 24.8303Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisadvantageTitleIcon);
export default __webpack_public_path__ + "static/media/disadvantage_title_icon.bef4bba00d1b7fcf20036424df4bc4e3.svg";
export { ForwardRef as ReactComponent };